export const Un  = "&username=projahdes"

 const GEO_API_URL_s = "https://myproxyapi.herokuapp.com/http://api.geonames.org/searchJSON?name_startsWith=jerusal&username=projahdes" ;

export const GEO_API_URL_SEARCH = "https://my-project-3-0.vercel.app/api/cities/search";
